/**
 * Signifies that it's not a specimen.
 */
export class NoSpecimen {
}
